module.exports = __webpack_public_path__ + "img/jppdimg_mo3.b397914d.png";